document.addEventListener("DOMContentLoaded", () => {
  const bar = document.getElementById('cookieBar');
  const btn = document.getElementById('cookieAcceptBtn');
  const music = document.getElementById('bgMusic');

  function fadeInMusic() {
    music.volume = 0.0;
    music.muted = false;

    let vol = 0;
    const fade = setInterval(() => {
      vol += 0.02;
      music.volume = vol;
      if (vol >= 0.7) clearInterval(fade);
    }, 120);
  }

  function tryPlay() {
    music.play().then(fadeInMusic).catch(() => {
      document.addEventListener("click", () => {
        music.play().then(fadeInMusic);
      }, { once: true });
    });
  }

  // ВСЕГДА показываем бар (НИКАКОГО СОХРАНЕНИЯ)
  bar.classList.remove('hide');

  btn.addEventListener('click', () => {
    bar.classList.add('hide');
    tryPlay();
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const backBtn = document.getElementById("backToTopBtn");
  if (!backBtn) return;

  backBtn.addEventListener("click", (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const map = {
    "effect-one-text": ".one-effect",
    "effect-two-text": ".two-effect",
    "effect-three-text": ".three-effect"
  };

  Object.entries(map).forEach(([textCls, itemSel]) => {
    const trigger = document.querySelector(`.${textCls}`);
    const item = document.querySelector(itemSel);
    if (!trigger || !item) return;

    const show = () => {
      item.classList.add("visible");
      trigger.classList.add("text-visible");
    };
    const hide = () => {
      item.classList.remove("visible");
      trigger.classList.remove("text-visible");
    };

    trigger.addEventListener("mouseenter", show);
    trigger.addEventListener("mouseleave", hide);
    trigger.addEventListener("focus", show);
    trigger.addEventListener("blur", hide);
    trigger.addEventListener("touchstart", show, { passive: true });
    trigger.addEventListener("touchend", hide, { passive: true });
  });
});



document.addEventListener("DOMContentLoaded", () => {
  try {
    let currentSlide = 0;
    const totalSlides = 6;

    const dots = document.querySelectorAll(".dot");
    const imageWrappers = document.querySelectorAll(".image-wrapper");
    const contentItems = document.querySelectorAll(".content-item");

    if (!dots.length || !imageWrappers.length || !contentItems.length) return;

    function goToSlide(slideIndex) {
      if (
        !imageWrappers[slideIndex] ||
        !contentItems[slideIndex] ||
        !dots[slideIndex]
      )
        return;

      imageWrappers[currentSlide]?.classList.remove("active");
      contentItems[currentSlide]?.classList.remove("active");
      dots[currentSlide]?.classList.remove("active");

      currentSlide = slideIndex;

      imageWrappers[currentSlide]?.classList.add("active");
      contentItems[currentSlide]?.classList.add("active");
      dots[currentSlide]?.classList.add("active");

      const textContent = contentItems[currentSlide].querySelector(".text-content");
      if (textContent) textContent.scrollTop = 0;

      // --- Мобильная логика ---
      if (window.innerWidth <= 768) {
        imageWrappers.forEach((img, i) => {
          if (i === currentSlide || i === (currentSlide + 1) % totalSlides) {
            img.style.display = "block";
            img.style.position = "relative";
            img.style.opacity = "1";
          } else {
            img.style.display = "block"; // оставляем block, чтобы absolute не ломал поток
            img.style.position = "absolute";
            img.style.opacity = "0";
          }
        });
      } else {
        // --- Десктоп ---
        imageWrappers.forEach((img) => {
          img.style.display = "";
          img.style.position = "";
          img.style.opacity = "";
        });
      }
    }

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => goToSlide(index));
    });

    const prevBtn = document.getElementById("prevSlide");
    const nextBtn = document.getElementById("nextSlide");

    if (prevBtn)
      prevBtn.addEventListener("click", () =>
        goToSlide((currentSlide - 1 + totalSlides) % totalSlides)
      );

    if (nextBtn)
      nextBtn.addEventListener("click", () =>
        goToSlide((currentSlide + 1) % totalSlides)
      );

    document.addEventListener("keydown", (e) => {
      if (e.key === "ArrowRight")
        goToSlide((currentSlide + 1) % totalSlides);
      else if (e.key === "ArrowLeft")
        goToSlide((currentSlide - 1 + totalSlides) % totalSlides);
    });

    let touchStartX = 0;
    let touchEndX = 0;

    document.addEventListener("touchstart", (e) => {
      touchStartX = e.changedTouches[0].screenX;
    });

    document.addEventListener("touchend", (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    });

    function handleSwipe() {
      if (touchStartX - touchEndX > 50)
        goToSlide((currentSlide + 1) % totalSlides);
      else if (touchEndX - touchStartX > 50)
        goToSlide((currentSlide - 1 + totalSlides) % totalSlides);
    }

    goToSlide(0);

  } catch (err) {
    console.warn("Slider init error:", err);
  }
});

// ----------------- Изолированный слайдер изображений (imageSlider) -----------------
document.addEventListener("DOMContentLoaded", () => {
  try {
    let currentSlide = 0;
    const totalSlides = 6;

    const imageWrappers = document.querySelectorAll(".image-wrapper");
    const contentItems  = document.querySelectorAll(".content-item");
    const allDots       = document.querySelectorAll(".dot"); // и десктоп, и мобильные

    if (!imageWrappers.length || !contentItems.length || !allDots.length) return;

    function setActiveSlideClasses(idx) {
      // снять active
      imageWrappers.forEach(el => el.classList.remove("active"));
      contentItems.forEach(el => el.classList.remove("active"));
      document.querySelectorAll(".dot.active").forEach(d => d.classList.remove("active"));

      // поставить active
      imageWrappers[idx]?.classList.add("active");
      contentItems[idx]?.classList.add("active");

      // активировать все дотсы с таким же data-slide
      document.querySelectorAll(`.dot[data-slide="${idx}"]`).forEach(d => {
        d.classList.add("active");
        d.setAttribute("aria-current", "true");
      });
      // сбросить aria у остальных
      document.querySelectorAll(`.dot:not([data-slide="${idx}"])`).forEach(d => {
        d.removeAttribute("aria-current");
      });

      // скролл текста
      const textContent = contentItems[idx].querySelector(".text-content");
      if (textContent) textContent.scrollTop = 0;
    }

    function goToSlide(slideIndex) {
      const idx = ((slideIndex % totalSlides) + totalSlides) % totalSlides; // нормализуем
      currentSlide = idx;
      setActiveSlideClasses(idx);
    }

    // первичная инициализация
    setActiveSlideClasses(currentSlide);

    // клики по дотсам (и десктоп, и мобильные)
    document.addEventListener("click", (e) => {
      const dot = e.target.closest(".dot");
      if (!dot) return;
      const s = parseInt(dot.dataset.slide, 10);
      if (Number.isFinite(s)) goToSlide(s);
    });

    // стрелки
    const prevBtn = document.getElementById("prevSlide");
    const nextBtn = document.getElementById("nextSlide");
    prevBtn && prevBtn.addEventListener("click", () => goToSlide(currentSlide - 1));
    nextBtn && nextBtn.addEventListener("click", () => goToSlide(currentSlide + 1));

    // клавиатура
    document.addEventListener("keydown", (e) => {
      if (e.key === "ArrowRight") goToSlide(currentSlide + 1);
      else if (e.key === "ArrowLeft") goToSlide(currentSlide - 1);
    });

    // свайпы
    let touchStartX = 0;
    document.addEventListener("touchstart", (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, {passive:true});
    document.addEventListener("touchend", (e) => {
      const dx = touchStartX - e.changedTouches[0].screenX;
      if (dx > 50) goToSlide(currentSlide + 1);
      else if (dx < -50) goToSlide(currentSlide - 1);
    }, {passive:true});
  } catch (err) {
    console.warn("Slider init error:", err);
  }
});



// ----------------- Функция-инициализатор для остальных слайдеров (fashion, art, coffee и т.д.) -----------------
// Важно: локальные названия, чтобы не конфликтовать с глобальным goToSlide
function initSliderById(id) {
    const sliderElement = document.getElementById(id);
    if (!sliderElement) return;

    const slides = sliderElement.querySelectorAll('.image-slide');
    const dots = sliderElement.querySelectorAll('.image-dot');
    if (!slides.length || !dots.length) return;

    let currentLocal = 0;
    let startXLocal = 0;
    let isDraggingLocal = false;

    function goToLocalSlide(index) {
        slides[currentLocal].classList.remove('active');
        dots[currentLocal].classList.remove('active');

        currentLocal = index;

        slides[currentLocal].classList.add('active');
        dots[currentLocal].classList.add('active');

        return currentLocal;
    }

    sliderElement.addEventListener('mousedown', (e) => {
        isDraggingLocal = true;
        startXLocal = e.clientX;
    });

    sliderElement.addEventListener('mousemove', () => {
        if (!isDraggingLocal) return;
    });

    sliderElement.addEventListener('mouseup', (e) => {
        if (!isDraggingLocal) return;
        isDraggingLocal = false;
        const endX = e.clientX;
        const diff = startXLocal - endX;
        if (Math.abs(diff) > 50) {
            if (diff > 0) {
                currentLocal = goToLocalSlide((currentLocal + 1) % slides.length);
            } else {
                currentLocal = goToLocalSlide((currentLocal - 1 + slides.length) % slides.length);
            }
        }
    });

    sliderElement.addEventListener('mouseleave', () => { isDraggingLocal = false; });

    sliderElement.addEventListener('touchstart', (e) => {
        startXLocal = e.touches[0].clientX;
    });

    sliderElement.addEventListener('touchend', (e) => {
        const endX = e.changedTouches[0].clientX;
        const diff = startXLocal - endX;
        if (Math.abs(diff) > 50) {
            if (diff > 0) {
                currentLocal = goToLocalSlide((currentLocal + 1) % slides.length);
            } else {
                currentLocal = goToLocalSlide((currentLocal - 1 + slides.length) % slides.length);
            }
        }
    });

    dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
            currentLocal = goToLocalSlide(idx);
        });
    });
}

// Инициализируем другие слайдеры (по id-ам в твоём HTML)
initSliderById('fashionSlider'); // если есть элемент с id fashionSlider
initSliderById('artSlider');
// initSliderById('coffeeSlider');



document.addEventListener("DOMContentLoaded", () => {
  const artSlider = document.getElementById("artSlider");
  if (!artSlider) return;

  const slides = artSlider.querySelectorAll(".image-slide");
  const dots = artSlider.querySelectorAll(".image-dot");
  const btnPrev = document.getElementById("artPrev");
  const btnNext = document.getElementById("artNext");

  let currentIndex = 0;

  const updateSlide = (index) => {
    slides.forEach((s, i) => s.classList.toggle("active", i === index));
    dots.forEach((d, i) => d.classList.toggle("active", i === index));
    currentIndex = index;
  };

  const nextSlide = () => {
    const nextIndex = (currentIndex + 1) % slides.length;
    updateSlide(nextIndex);
  };

  const prevSlide = () => {
    const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
    updateSlide(prevIndex);
  };

  btnNext.addEventListener("click", nextSlide);
  btnPrev.addEventListener("click", prevSlide);
});


// --- кнопки "вперёд"/"назад" только для coffeeSlider ---
// const coffeeSlider = document.getElementById("coffeeSlider");
// if (coffeeSlider) {
//   const slides = coffeeSlider.querySelectorAll(".image-slide");
//   const dots = coffeeSlider.querySelectorAll(".image-dot");
//   const prevBtn = document.getElementById("coffeePrev");
//   const nextBtn = document.getElementById("coffeeNext");
//   let current = 0;

//   function goToCoffeeSlide(index) {
//     slides[current].classList.remove("active");
//     dots[current].classList.remove("active");
//     current = (index + slides.length) % slides.length;
//     slides[current].classList.add("active");
//     dots[current].classList.add("active");
//   }

//   prevBtn?.addEventListener("click", () => goToCoffeeSlide(current - 1));
//   nextBtn?.addEventListener("click", () => goToCoffeeSlide(current + 1));
// }
